export default class LivestreamingTitle {

  constructor({ element }) {
    this.element = element;
    this.livestreamingId = element.dataset.livestreamingId;
    this.currentTime = new Date();
  }

  init() {
    this.fetchSchedule();
  }

  setLivestreamingTitle(response) {
    if (response !== undefined) {
      response.forEach(function(resource) {
        let startTime = new Date(resource.start_time) || this.currentTime;
        let scheduledTime = startTime - this.currentTime;

        setTimeout(() => {
          this.modifyElement(resource);

          clearTimeout(scheduledTime);
        }, scheduledTime);
      }.bind(this))
    }
  }

  fetchSchedule(){
    let url = `/live/${this.livestreamingId}/schedules/current_and_upcoming`;

    $.get(url)
      .done(this.setLivestreamingTitle.bind(this));
  }

  modifyElement(resource) {
    let livestreamingTitleElement = this.element.querySelector('h1.section__title')
    let scheduleTitleElement = this.element.querySelector('h2.section__title')
    let concurrentElement = this.element.querySelector('.livestreaming-info__user-concurrent')
    let separatorElement = document.createElement('span')
    separatorElement.classList.add('livestreaming-info__text')
    let titleElement = document.createElement('span')
    titleElement.classList.add('livestreaming-info__text')

    livestreamingTitleElement.classList.add('hide')
    scheduleTitleElement.innerText = resource.title

    if (concurrentElement.firstElementChild != undefined &&
      concurrentElement.firstElementChild.innerText == resource.livestreaming_title) {
      return
    }

    if (concurrentElement.childElementCount > 0) {
      concurrentElement.insertBefore(separatorElement, concurrentElement.firstElementChild)
      separatorElement.innerText = '\xa0·\xa0'
    }

    concurrentElement.insertBefore(titleElement, concurrentElement.firstElementChild)
    titleElement.innerText = resource.livestreaming_title
  }
}

